export const DEFAULT_ACTION = "app/AssignedBlocksOpenCases/DEFAULT_ACTION";
export const FORMDATA = "app/AssignedBlocksOpenCases/BLOCKDATA";
export const SETFORMDATA = "app/AssignedBlocksOpenCases/BLOCKDATA/SET/VALUE";
